import React, { useState, useEffect } from "react";
import enquiryClasses from "./enquiry.module.css";
import Layout from "../../Components/Layout/index";
import { Helmet } from "react-helmet";
import { Services } from "../../Services";
import SkeletonLoad from "./TableLoad/load";
import { Error } from "../../Util/Toast";
import Moment from "react-moment";

function Enquiry() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const getAllCategories = () => {
        Services.enquiry_List("GET", null, token)
            .then((response) => {
                console.log(response);
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setData(response.Enquires);
                } else if (response.Status === 0) {
                    Error(response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    useEffect(() => {
        getAllCategories(2);
        // eslint-disable-next-line
    }, []);

    return (
        <Layout Active={"EnquiryForm"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Enquiry List</title>
            </Helmet>
            <div className={enquiryClasses["Container"]}>
                <div className={enquiryClasses["control-btns"]}></div>
                <div className={enquiryClasses["Tutor"]}>
                    <h3> Enquiry </h3>
                    {loading ? (
                        <SkeletonLoad count={3} />
                    ) : data.length > 0 ? (
                        <div className={enquiryClasses["Table"]}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Name </th>
                                        <th>MobileNumber </th>
                                        <th>EmailID </th>
                                        <th>Mode Of Learning </th>
                                        <th style={{ maxWidth: "200px" }}>
                                            Comments
                                        </th>
                                        <th>Created At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item) => (
                                        <tr>
                                            <td>
                                                {" "}
                                                {item.FirstName} {item.LastName}
                                            </td>
                                            <td> {item.MobileNumber}</td>
                                            <td>{item.EmailID}</td>
                                            <td>{item.ModeOfLearning}</td>
                                            <td>{item.Comments}</td>

                                            <td>
                                                <Moment format="DD-MM-YYYY">
                                                    {new Date(item.CreatedAt)}
                                                </Moment>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div>
                            {" "}
                            <p>No Data Found</p>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Enquiry;
